import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import {useDispatch} from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import {getSelectedDepartment} from "../../actions/department";
import { isSuper } from '../../shared/authentication/authentication';
import { storeInLocalStorage } from '../../shared/util/utils';


const DepartmentItem = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [dropDown, setDropDown] = useState(false);

    function clickArrowDown() {
        setDropDown(true);
    }

    function clickArrowUp() {
        setDropDown(false);
    }

    const goToMachine = () => {
        dispatch(getSelectedDepartment(props.department));
        storeInLocalStorage("depId", props.department.id);
        storeInLocalStorage("firstNav", props.department.name);
        history.push(props.department.id + "/machine");
    };


    return (
        <div className="single-card">
            <div className="single-card-header-departmentList">
                <div className="row">
                    <div className="col-5 margin-auto">
                        <div className="card-header-text-departmentList">
                            {props.department.name === "" | props.department.name == null ?
                                <div className="heading-machine limit-sensorName-sa">Department Name</div>:
                                <div className="heading-machine limit-department-header-name">{props.department.name}</div>
                            }
                        </div>
                    </div>
                    <div className="col-6 margin-auto text-right">
                        <div  className="card-header-actions">
                            <FeatherIcon className={"text-white"} icon="clipboard"/>
                        </div>
                    </div>
                    {
                        isSuper() && <div className="col-1">
                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-custom-components-factoryspy">
                                    <FeatherIcon className={dropDown ? "vertical-icon-b vertical-icon-bb text-white": "vertical-icon-b text-white"} icon="more-vertical" />

                                    {dropDown ? <div onClick={clickArrowUp.bind(this)} className="bell-icon text-black"></div> :
                                        <div onClick={clickArrowDown.bind(this)} className="bell-icon"></div>
                                    }
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() =>{
                                    props.parentCallbackEdit(props.department.id,props.index,props.department.name);
                                    }}>
                                        <FeatherIcon
                                            className="spy-actions-icon" icon="edit"/><label className="spy-actions">Edit</label>
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => props.parentCallback(props.department.id)} >
                                        <FeatherIcon
                                            className="spy-actions-icon" icon="trash-2"/><label className="spy-actions">Delete</label>
                                    </Dropdown.Item>
                                    <Dropdown.Item>
                                        <FeatherIcon
                                            className="spy-actions-icon" icon="settings"/><label className="spy-actions">Setting</label>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    }
                </div>
            </div>
            <div className="single-card-contentDepartmentList sa-cursor" onClick={goToMachine}>
                <div className="row p-1">
                    <div className="col-6" >
                        <div className="details-department">
                            <div className="sensor-icon-departmentList status-green">
                                <FeatherIcon className={""} icon="hard-drive"/>
                            </div>
                            <div className="sensor-data-varna">
                                {props.department.noOfActive === "" | props.department.noOfActive == null ?
                                    <div className="sensor-value sensor-font-weight">0</div>:
                                    <div className="sensor-value sensor-font-weight">{props.department.noOfActive}</div>
                                }
                                <div className="department-status">Working</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6" >
                        <div className="details-department">
                            <div className="sensor-icon-departmentList status-red">
                                <FeatherIcon className={""} icon="git-pull-request"/>
                            </div>
                            <div className="sensor-data-varna">
                                {props.department.noOfDowntime === "" | props.department.noOfDowntime == null ?
                                    <div className="sensor-value sensor-font-weight">0</div>:
                                    <div className="sensor-value sensor-font-weight">{props.department.noOfDowntime}</div>
                                }
                                <div className="department-status">DownTime</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="single-card-header-departmentList-machinesCount sa-cursor" onClick={goToMachine}>
                <div className="fs-icon-total-machines status-blue"><FeatherIcon className={""} icon="inbox"/>
                    <div>
                        {props.department.noOfMachines === "" | props.department.noOfMachines == null?
                            <div className="machine-value">0</div>:
                            <div className="machine-value">{props.department.noOfMachines}</div>
                        }
                        <div className="machine-Name ">Total Machines</div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default DepartmentItem;
